import InfoTooltip from '../InfoTooltip/InfoTooltip';
import styles from './StatCard.module.css';

function StatCard({ label, value, icon: Icon, info = false, tooltip, subValue, className, headerClassName }) {
  return (
    <div className={`${styles.card}${className ? ` ${className}` : ''}`}>
      <div className={`${styles.header}${headerClassName ? ` ${headerClassName}` : ''}`}>
        <div className={styles.labelRow}>
          <span className={styles.label}>{label}</span>
          {info && tooltip && (
            <InfoTooltip title={tooltip.title} text={tooltip.text} />
          )}
        </div>
        <div className={styles.iconBox}>
          <Icon size={20} />
        </div>
      </div>
      <div className={styles.value}>{value}</div>
      {subValue && <div className={styles.subValue}>{subValue}</div>}
    </div>
  );
}

export default StatCard;
